import { all, call, put, takeEvery } from "redux-saga/effects";
import * as tenantUserActions from "../slices/tenantUserSlice";

import tenantUserApis from "src/api/tenantUser";

import { common } from "src/types/index";
import { TenantUserListParams, TenantUserRequest } from "src/types/tenantUser.types";
import { constants } from "src/constants/common";

// create tenant user saga
const CreateTenantUserSaga = function* CreateTenantUserSaga({
  payload,
}: ReturnType<typeof tenantUserActions.createTenantUserRequest> & {
  payload: TenantUserRequest;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      tenantUserApis.createTenantUser,
      payload
    );

    yield put(tenantUserActions.createTenantUserSuccess(response));
  } catch (error) {
    yield put(
      tenantUserActions.createTenantUserError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

// edit tenant user saga
const EditTenantUserSaga = function* EditTenantUserSaga({
  payload,
}: ReturnType<typeof tenantUserActions.editTenantUserRequest> & {
  payload: TenantUserRequest;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      tenantUserApis.editTenantUser,
      payload
    );

    yield put(tenantUserActions.editTenantUserSuccess(response));
  } catch (error) {
    yield put(
      tenantUserActions.editTenantUserError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

// get tenant user list saga
const GetTenantUserListSaga = function* GetTenantUserListSaga({
  payload,
}: ReturnType<typeof tenantUserActions.getTenantUserListRequest> & {
  payload: TenantUserListParams;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      tenantUserApis.getTenantUserList,
      payload
    );

    yield put(tenantUserActions.getTenantUserListSuccess(response));
  } catch (error) {
    yield put(
      tenantUserActions.getTenantUserListError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

// change password tenant user saga
const ChangeTenantUserPasswordSaga = function* ChangeTenantUserPasswordSaga({
  payload,
}: ReturnType<typeof tenantUserActions.changeTenantUserPasswordRequest> & {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      tenantUserApis.changeTenantUserPassword,
      payload
    );

    yield put(tenantUserActions.editTenantUserSuccess(response));
  } catch (error) {
    yield put(
      tenantUserActions.editTenantUserError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

export default function* tenantSaga() {
  yield all([
    takeEvery(tenantUserActions.createTenantUserRequest, CreateTenantUserSaga),
  ]);
  yield all([
    takeEvery(tenantUserActions.editTenantUserRequest, EditTenantUserSaga),
  ]);
  yield all([
    takeEvery(
      tenantUserActions.getTenantUserListRequest,
      GetTenantUserListSaga
    ),
  ]);
  yield all([
    takeEvery(
      tenantUserActions.changeTenantUserPasswordRequest,
      ChangeTenantUserPasswordSaga
    ),
  ]);
}
